import React from "react";

export const ReadonlyField = ({name, value}) => {
    return <p><span className={"font-bold " + (name ? "mr-3" : "")}>{name}</span>{value}</p>
}
